import { render, staticRenderFns } from "./FutureRules.vue?vue&type=template&id=f879e322&scoped=true"
import script from "./FutureRules.vue?vue&type=script&lang=js"
export * from "./FutureRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f879e322",
  null
  
)

export default component.exports